module.exports = __webpack_public_path__ + "media/images/photography/grown_up_cms/addi-97b4b698589dd7c90dd6c9f1876ad5ec.jpg";